module.exports = __webpack_public_path__ + "static/media/shield.ef3c0b52.svg";